import React from 'react';

export default function Login() {
  return (
    <div className="card">
      <h2>Log in</h2>
      <p>To continue, please log in with Discord.</p>
      <a className="button" href="/api/auth/login">Log in with Discord</a>
    </div>
  );
}